import { Dispatch } from 'react';
import { Action, Reducer } from 'redux';
import InstanceClient from '../../services/InstanceClient';
import {
    CoreClassroomAdminDashboard,
    CoreClassroomAdminDashboardOwnerCount,
    CoreClassroomAdminDashboardSchoolCount
} from '../../models/CoreClassroomAdminClassroom';
import { RequestState } from '../../models/RequestState';
import StatusCode from '../../util/StatusCode';
import { ClassroomAdminClassroomPageRequest } from '../../models/Requests';

enum ClassroomAdminDashboardActionType {
    DASHBOARD = 'CLASSROOMADMIN_DASHBOARD',
    DASHBOARD_OWNERS = 'CLASSROOMADMIN_DASHBOARD_OWNERS',
    DASHBOARD_SCHOOLS = 'CLASSROOMADMIN_DASHBOARD_SCHOOLS'
}

export interface ClassroomAdminDashboardState {
    dashboard: RequestState<CoreClassroomAdminDashboard>
    owners: RequestState<CoreClassroomAdminDashboardOwnerCount[]>
    schools: RequestState<CoreClassroomAdminDashboardSchoolCount[]>
}

interface ClassroomAdminDashboard_Get extends Action<ClassroomAdminDashboardActionType.DASHBOARD> {
    type: ClassroomAdminDashboardActionType.DASHBOARD
    dashboard: RequestState<CoreClassroomAdminDashboard>
}

interface ClassroomAdminDashboard_GetOwners extends Action<ClassroomAdminDashboardActionType.DASHBOARD_OWNERS> {
    type: ClassroomAdminDashboardActionType.DASHBOARD_OWNERS
    owners: RequestState<CoreClassroomAdminDashboardOwnerCount[]>
}

interface ClassroomAdminDashboard_GetSchools extends Action<ClassroomAdminDashboardActionType.DASHBOARD_SCHOOLS> {
    type: ClassroomAdminDashboardActionType.DASHBOARD_SCHOOLS
    schools: RequestState<CoreClassroomAdminDashboardSchoolCount[]>
}

type ClassroomAdminDashboardAction =
    | ClassroomAdminDashboard_Get
    | ClassroomAdminDashboard_GetOwners
    | ClassroomAdminDashboard_GetSchools;

export const getClassroomAdminDashboardInfo = (filter?: Partial<ClassroomAdminClassroomPageRequest>) => (dispatch: Dispatch<ClassroomAdminDashboard_Get>) => {
    InstanceClient.get<CoreClassroomAdminDashboard>('/api/core/classroomadmin/dashboard', filter)
        .then(res => dispatch({
            type: ClassroomAdminDashboardActionType.DASHBOARD,
            dashboard: { code: StatusCode.COMPLETE, data: res.data }
        }))
        .catch(error => dispatch({
            type: ClassroomAdminDashboardActionType.DASHBOARD,
            dashboard: { code: StatusCode.ERROR, error }
        }));
};

export const getClassroomAdminDashboardOwners = () => (dispatch: Dispatch<ClassroomAdminDashboard_GetOwners>) => {
    InstanceClient.get<CoreClassroomAdminDashboardOwnerCount[]>('/api/core/classroomadmin/dashboard/owners')
        .then(res => dispatch({
            type: ClassroomAdminDashboardActionType.DASHBOARD_OWNERS,
            owners: { code: StatusCode.COMPLETE, data: res.data }
        }))
        .catch(error => dispatch({
            type: ClassroomAdminDashboardActionType.DASHBOARD_OWNERS,
            owners: { code: StatusCode.ERROR, error }
        }));
};

export const getClassroomAdminDashboardSchools = () => (dispatch: Dispatch<ClassroomAdminDashboard_GetSchools>) => {
    InstanceClient.get<CoreClassroomAdminDashboardSchoolCount[]>('/api/core/classroomadmin/dashboard/schools')
        .then(res => dispatch({
            type: ClassroomAdminDashboardActionType.DASHBOARD_SCHOOLS,
            schools: { code: StatusCode.COMPLETE, data: res.data }
        }))
        .catch(error => dispatch({
            type: ClassroomAdminDashboardActionType.DASHBOARD_SCHOOLS,
            schools: { code: StatusCode.ERROR, error }
        }));
};

const initialState: ClassroomAdminDashboardState = {
    dashboard: { code: StatusCode.PENDING },
    owners: { code: StatusCode.PENDING },
    schools: { code: StatusCode.PENDING }
};

export const reducer: Reducer<ClassroomAdminDashboardState, ClassroomAdminDashboardAction> = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case ClassroomAdminDashboardActionType.DASHBOARD:
            return { ...state, dashboard: action.dashboard };
        case ClassroomAdminDashboardActionType.DASHBOARD_OWNERS:
            return { ...state, owners: action.owners };
        case ClassroomAdminDashboardActionType.DASHBOARD_SCHOOLS:
            return { ...state, schools: action.schools };
        default:
            return state;
    }
};